import useFetchService from '@/composables/useFetchService';

export default function usePictureService() {
  /********************
   * COMPOSITIONS      *
   ********************/
  const runtimeConfig = useRuntimeConfig();
  const fetchService = useFetchService({ base: runtimeConfig.public.apiUrl });

  /********************
   * FUNCTIONS         *
   ********************/
  function create(lang: string, data: any) {
    return fetchService.post('/pictures/', lang, data);
  }

  return {
    create,
  };
}
